import React from 'react'
import accounting from 'accounting'
import { Link } from 'react-router-dom'

import Banner from '../../../../components/Banner'
import Progress from '../../../../components/Progress'
import Actions from '../../../../components/Actions'
import IconDrawGirl from '../../../../svg/drawGirl.svg'
import Pagination from '../../../../components/Pagination'

import PROJECT_TYPES from '../../../../common/constants/ProjectTypes'

import { getDate, getDateTime, getMoment } from '../../../../utils/dateTime'
import { formattedTime } from '../../../../utils/formatter'
import { IconCopyLink, IconDelete, IconDuplicate, IconWarningTriangle } from '../../../../svg'

export const PublishedTab = ({
    projects,
    t,
    viewsConstraints,
    getTranslation,
    openModal,
    editClick,
    openShareModal,
    duplicateProject,
    actionLoading,
    isTrial,
    isTrialOrTrialEndedProduct,
    openTrialModal,
    paginationClick,
}) => {
    return (
        <div className={`tab-content${projects.drafts.isLoading ? ' dim' : ''}`}>
            {viewsConstraints.total - viewsConstraints.value <= 0 && !isTrialOrTrialEndedProduct ? (
                <Banner
                    variant="danger"
                    padding="normal"
                    reason_id={2}
                    reason_data={{
                        current: accounting.formatNumber(viewsConstraints.value, {
                            thousand: ' ',
                        }),
                        total: accounting.formatNumber(viewsConstraints.total, { thousand: ' ' }),
                    }}
                />
            ) : (projects.published.content.length || viewsConstraints.value > 0) && !isTrialOrTrialEndedProduct ? (
                <Progress
                    value={viewsConstraints.value}
                    total={viewsConstraints.total}
                    title={t('_pages._my_projects.views_by_all_projects')}
                    date={`${getDate(viewsConstraints.start)} - ${getDate(viewsConstraints.end)}`}
                    units={t('_pages._my_projects.views_2')}
                />
            ) : null}

            {projects.published.content.length ? (
                <ul className={`project-list${projects.published.isLoading ? ' dim' : ''}`}>
                    {projects.published.content.map(item => {
                        return (
                            <li
                                className={`item${item.isRemoved ? ' is-removed' : ''}${
                                    item.projectBlockStatus === 'BLOCKED' ? ' is-blocked' : ''
                                }`}
                                key={item.id}
                                data-deleted-text="deleted"
                                data-blocked-text="blocked"
                            >
                                <div className="mobile-box">
                                    <div className="head">
                                        <div className="name">
                                            <h3>{item.name}</h3>
                                            <div
                                                style={{
                                                    color: item.projectType.color,
                                                    borderColor: item.projectType.color,
                                                }}
                                            >
                                                {/* START > Временно пока нет многоязычности в админке */}
                                                {getTranslation(item.projectType.customId, 'name')}
                                                {/* END */}
                                                {/*{item.projectType.name}*/}
                                            </div>
                                        </div>
                                        <div className="actions us-n">
                                            <div>
                                                <ul className="btn" onClick={openModal('mobile_actions', item)}>
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <ul className="stats">
                                        <li>
                                            <div className="name">{t('_pages._my_projects.views_uppercase')}</div>
                                            <div className="value">
                                                {accounting.formatNumber(item.sessionCount, {
                                                    thousand: ' ',
                                                })}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="name">{t('_pages._my_projects.users')}</div>
                                            <div className="value">
                                                {accounting.formatNumber(item.uniqueUsersCount, {
                                                    thousand: ' ',
                                                })}
                                            </div>
                                        </li>
                                        <li>
                                            <div className="name">{t('_pages._my_projects.avg_time')}</div>
                                            <div className="value">{formattedTime(item.avgSessionTime)}</div>
                                        </li>
                                    </ul>
                                    {item.previewUrl && item.mobilePreviewUrl ? (
                                        <div className="images">
                                            <div className="image-container image-container--desktop">
                                                <div className="layout">
                                                    <ul>
                                                        <li></li>
                                                        <li></li>
                                                        <li></li>
                                                    </ul>
                                                </div>
                                                <img src={item.previewUrl} alt="" />
                                            </div>
                                            <div className="image-container image-container--mobile">
                                                <div className="layout">
                                                    <span></span>
                                                </div>
                                                <img src={item.mobilePreviewUrl} alt="" />
                                            </div>
                                        </div>
                                    ) : null}
                                    <div className="buttons">
                                        <div>
                                            <a
                                                href={item.projectVersions[0].publicUrl}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="button-style"
                                                data-size="md"
                                                data-variant="secondary"
                                            >
                                                {t('_common.view')}
                                            </a>
                                            <button
                                                className="button"
                                                data-size="md"
                                                data-variant="secondary"
                                                onClick={editClick(item)}
                                            >
                                                {t('Edit')}
                                            </button>
                                        </div>
                                        {item.projectType.projectType === PROJECT_TYPES.blockArticle && (
                                            <div>
                                                <Link
                                                    to={`/account/my-projects/${item.projectId}/analytics`}
                                                    className="button-style"
                                                    data-size="md"
                                                    data-variant="primary"
                                                >
                                                    {t('_pages._my_projects.view_detailed_stats_2')}
                                                </Link>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                <div className="box">
                                    <div className="block block--1 us-n">
                                        <div className="image-container image-container--desktop">
                                            <div className="layout">
                                                <ul>
                                                    <li></li>
                                                    <li></li>
                                                    <li></li>
                                                </ul>
                                            </div>
                                            {item.previewUrl ? (
                                                <img src={item.previewUrl} alt="" />
                                            ) : (
                                                <div className="no-image"></div>
                                            )}
                                        </div>
                                        <div className="image-container image-container--mobile">
                                            <div className="layout">
                                                <span></span>
                                            </div>
                                            {item.mobilePreviewUrl ? (
                                                <img src={item.mobilePreviewUrl} alt="" />
                                            ) : (
                                                <div className="no-image"></div>
                                            )}
                                        </div>
                                    </div>
                                    <div className="block block--2">
                                        <div className="block block--1">
                                            <h3>{item.name}</h3>
                                            <div
                                                className="category us-n"
                                                style={{
                                                    color: item.projectType.color,
                                                    borderColor: item.projectType.color,
                                                }}
                                            >
                                                {/* START > Временно пока нет многоязычности в админке */}
                                                {getTranslation(item.projectType.customId, 'name')}
                                                {/* END */}
                                                {/*{item.projectType.name}*/}
                                            </div>
                                        </div>
                                        <div className="block block--2">
                                            {item.updated > item.published && (
                                                <p className="unpublished-changes">
                                                    <IconWarningTriangle />{' '}
                                                    <span>
                                                        {t('_pages._my_projects.project_has_unpublished_changes')}
                                                    </span>
                                                </p>
                                            )}
                                            {getMoment(item.updated).isValid() && (
                                                <div>
                                                    {t('_pages._my_projects.last_modified')}:{' '}
                                                    {getDateTime(item.updated)}
                                                </div>
                                            )}
                                            {getMoment(item.published).isValid() && (
                                                <div>
                                                    {t('_pages._my_projects.published_2')}: {getDateTime(item.updated)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="box">
                                    <div className="block block--3">
                                        <Actions width="190px" align="right">
                                            <div className="block block--1">
                                                <ul className="items-1">
                                                    <li onClick={isTrial ? openTrialModal() : openShareModal(item)}>
                                                        <span className="icon" data-icon="copyLink">
                                                            <IconCopyLink />
                                                        </span>
                                                        {t('_common.copy_link')}
                                                    </li>
                                                    <li
                                                        className={actionLoading.duplicateProject ? 'is-loading' : ''}
                                                        onClick={isTrial ? openTrialModal() : duplicateProject(item)}
                                                    >
                                                        <span className="icon" data-icon="duplicate">
                                                            <IconDuplicate />
                                                        </span>
                                                        {t('_pages._my_projects.duplicate_project')}
                                                    </li>
                                                    <li onClick={openModal('delete_project', item)}>
                                                        <span className="icon" data-icon="delete">
                                                            <IconDelete />
                                                        </span>
                                                        {t('_common.delete')}
                                                    </li>
                                                </ul>
                                            </div>
                                        </Actions>
                                        <div className="block block--1">
                                            <ul className="stats">
                                                <li data-col="views">
                                                    <div className="value">
                                                        {accounting.formatNumber(item.sessionCount, { thousand: ' ' })}
                                                    </div>
                                                    <div className="label">
                                                        {t('_pages._my_projects.views_uppercase')}
                                                    </div>
                                                </li>
                                                <li data-col="users">
                                                    <div className="value">
                                                        {accounting.formatNumber(item.uniqueUsersCount, {
                                                            thousand: ' ',
                                                        })}
                                                    </div>
                                                    <div className="label">{t('_pages._my_projects.users')}</div>
                                                </li>
                                                <li data-col="time">
                                                    <div className="value">{formattedTime(item.avgSessionTime)}</div>
                                                    <div className="label">{t('_pages._my_projects.avg_time')}</div>
                                                </li>
                                            </ul>
                                        </div>
                                        <div className="block block--2">
                                            <div className="button-list">
                                                <a
                                                    href={item.projectVersions[0].publicUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="button-style"
                                                    data-size="md"
                                                    data-variant="secondary"
                                                >
                                                    {t('_common.view')}
                                                </a>
                                                <button
                                                    className="button"
                                                    data-size="md"
                                                    data-variant="secondary"
                                                    onClick={isTrial ? openTrialModal() : editClick(item)}
                                                >
                                                    {t('Edit')}
                                                </button>
                                                {item.projectType.projectType === PROJECT_TYPES.blockArticle && (
                                                    <Link
                                                        to={
                                                            isTrial
                                                                ? '#'
                                                                : `/account/my-projects/${item.projectId}/analytics`
                                                        }
                                                        className="button-style"
                                                        data-size="md"
                                                        data-variant="primary"
                                                        data-test="view-detail-stats"
                                                        onClick={isTrial ? openTrialModal() : null}
                                                    >
                                                        {t('_pages._my_projects.view_detailed_stats_2')}
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        )
                    })}
                </ul>
            ) : projects.published.isLoading ? (
                'Loading'
            ) : (
                <div className="empty">
                    <div className="image">
                        <img src={IconDrawGirl} alt="" />
                    </div>
                    <h3>{t('_pages._my_projects.text_6')}</h3>
                    <h4>{t('_pages._my_projects.text_7')}</h4>
                    <div className="buttons">
                        <Link to={`/template-gallery`} className="button-style" data-size="lg" data-variant="primary">
                            {t('_pages._my_projects.create_from_template')}
                        </Link>
                    </div>
                </div>
            )}

            <div className={`pagination-wrapper${projects.published.pagination.totalPages > 1 ? ' is-visible' : ''}`}>
                <Pagination
                    settings={{ disableInitCallback: true, marginPages: 1, pageRange: 4 }}
                    data={{
                        currentPage: projects.published.pagination.offsetPages,
                        totalPages: projects.published.pagination.totalPages,
                    }}
                    events={{ handleClick: paginationClick('published') }}
                />
            </div>
        </div>
    )
}
